class KlaviyoExtensions {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
    }

    onInit () {
        this._BtnColor()
    }

    _BtnColor () {
        const checkbox = document.querySelector('#consent-web')
        const btn = document.querySelectorAll('.newsletter__antilcheched')
        const msg = document.querySelector('.customised_msgs')
        const msgSuccess = document.querySelector('.success_message_es')

        if (checkbox === null || btn[0] === null || btn[1] === null) return

        checkbox.addEventListener('change', function () {
            if (this.checked) {
                btn[0].classList.add('blue')
                btn[0].disabled = false
                // mobile
                btn[1].classList.add('blue')
                btn[1].disabled = false
            } else {
                btn[0].classList.remove('blue')
                btn[0].disabled = true
                // mobile
                btn[1].classList.remove('blue')
                btn[1].disabled = true
            }
        })

        if (msg === null || msgSuccess === null) return

        btn[0].addEventListener('click', function () {
            if (checkbox.checked) {
                msg.classList.remove('show')
            } else {
                msg.classList.add('show')
            }
            const input = document.querySelector('.newsletter__input')
            if (checkbox.checked && input.value.includes('@')) {
                msgSuccess.classList.add('show')
                msg.classList.remove('show')
            } else {
                msg.classList.add('show')
            }
        })

        btn[1].addEventListener('click', function () {
            if (checkbox.checked) {
                msg.classList.remove('show')
            } else {
                msg.classList.add('show')
            }
            const input = document.querySelector('.newsletter__input')
            if (checkbox.checked && input.value.includes('@')) {
                msgSuccess.classList.add('show')
                msg.classList.remove('show')
            } else {
                msg.classList.add('show')
            }
        })
    }
}

export default KlaviyoExtensions



// WEBPACK FOOTER //
// ./src/resources/scripts/components/KlaviyoExtensions.js